import { BreadcrumbProps } from "components/Page";
import { useMemo } from "react";
import { useParams } from "react-router";
import { EtudeStep, getAppUrl } from "utils/defines";
import useTranslation from "utils/hooks/useTranslation";
import { EtudeTypes } from "../constants";
import { getSolutionNomDeProposition } from "../Solutions/SolutionDetails/helpers";
import { useCurrentEtudeData } from "./useCurrentEtudeData";
import { useMatchEtudePath } from "./useMatchEtudePath";

export const getTranslationKeyByEtudeType = (etudeType?: string) => {
  switch (etudeType) {
    case EtudeTypes.chauffage:
      return "FO_SERVICE_HEATING";
    case EtudeTypes.chauffageECS:
      return "FO_SERVICE_HEATING_AND_WATER";
    case EtudeTypes.ECS:
      return "FO_SERVICE_WATER_ONLY";
  }
  return "";
};

export const useEtudeBreadcrumbItems = () => {
  const { t } = useTranslation();
  const { etudeType } = useParams();
  const { selectedDetail, solution, etudeId } = useCurrentEtudeData();

  const { matchEtudePath } = useMatchEtudePath();
  const { breadcrumbItems, title } = useMemo(() => {
    const detailUrlEncoded = encodeURIComponent(selectedDetail ?? "");
    let title = `${t("FO_BANDEAU_INPUT")} - ${t(
      getTranslationKeyByEtudeType(etudeType),
    )}`;

    const breadcrumbItems: BreadcrumbProps[] = [];
    if (matchEtudePath(EtudeStep.Solutions)) {
      breadcrumbItems.push({
        text: title,
        link: getAppUrl(`/etude/${etudeType}/${etudeId!}`),
        step: EtudeStep.InputForm,
      });
      title = t("FO_BANDEAU_SOLUTION");

      if (matchEtudePath(EtudeStep.SolutionDetails) && solution) {
        breadcrumbItems.push({
          text: title,
          link: getAppUrl(`/etude/${etudeType}/${etudeId}/solutions`),
          step: EtudeStep.Solutions,
        });
        title = `${t("FO_BANDEAU_DETAILS")} ${getSolutionNomDeProposition(
          solution!,
        )}`;

        if (matchEtudePath(EtudeStep.Accessoires)) {
          breadcrumbItems.push({
            text: title,
            link: getAppUrl(
              `/etude/${etudeType}/${etudeId}/solutions/${detailUrlEncoded}`,
            ),
            step: EtudeStep.SolutionDetails,
          });
          title = t("FO_BANDEAU_ACCESSORIES");

          if (matchEtudePath(EtudeStep.Documents)) {
            breadcrumbItems.push({
              text: title,
              link: getAppUrl(
                `/etude/${etudeType}/${etudeId}/solutions/${detailUrlEncoded}/accessoires`,
              ),
              step: EtudeStep.Accessoires,
            });
            title = t("FO_BANDEAU_END");
          }
        }
      }
    }
    return { breadcrumbItems, title };
  }, [t, solution, etudeId, etudeType, matchEtudePath]);

  return { breadcrumbItems, title };
};
